import {Component, Input, OnInit} from '@angular/core';
import {Product} from 'src/app/product-details/interface/product';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {PreOrderVolumeDiscountCalculationService} from '../service/pre-order-volume-discount-calculation.service';
import {CurrencyResolverService} from "../../../../currency-resolver.service";
import {ApCurrency} from "../../../../pipe/enum/ap-currency";

@Component({
	selector: 'fb-pre-order-price',
	templateUrl: './pre-order-price.component.html',
	styleUrls: ['./pre-order-price.component.scss']
})
export class PreOrderPriceComponent implements OnInit{

	@Input() productData: Product = {} as Product;
	@Input() preOrderQuantity: number = 0;


	public price: number = 0;
	public discounterPrice: number = 0;

	public undiscountedPrice: number = 0;
	public storediscountedPrice: number = 0;
	public selectedCurrency: ApCurrency = ApCurrency.USD;

	constructor(
		private _priceCalculation: PriceCalculationService,
		private _currencyResolver: CurrencyResolverService,
		private _preOrderVolumeDiscountCalc: PreOrderVolumeDiscountCalculationService
	) {

	}

	public ngOnInit(): void {

		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		if(this._priceCalculation.storePrice) {
			this.price = this._priceCalculation.storePrice;
			this.undiscountedPrice = this._priceCalculation.storeUndiscountedPrice;
			this.storediscountedPrice = this._priceCalculation.storediscountedPrice;
		}
		else {
			this.price = this.productData.price;
		}

		// this.discounterPrice = this._preOrderVolumeDiscountCalc.calculatePreOrderVolumeDIscountPrice(
		// 	this.price,
		// 	this.preOrderQuantity,
		// 	this.productData
		// )

		this._priceCalculation.observePrice.subscribe((data: number): void => {
			this.price = data;
			this.undiscountedPrice = this._priceCalculation.storeUndiscountedPrice;
			this.storediscountedPrice = this._priceCalculation.storediscountedPrice;

		});

	}

	public ngOnChanges(changes: any): void {
		// debugger
		this.preOrderQuantity = changes['preOrderQuantity'].currentValue;

		// this.discounterPrice = this._preOrderVolumeDiscountCalc.calculatePreOrderVolumeDIscountPrice(
		// 	this.price,
		// 	this.preOrderQuantity,
		// 	this.productData
		// )
	}
}
